/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AlarmSort { 
    key?: string;
    direction?: AlarmSort.DirectionEnum;
}
export namespace AlarmSort {
    export type DirectionEnum = 'ASC' | 'DESC';
    export const DirectionEnum = {
        ASC: 'ASC' as DirectionEnum,
        DESC: 'DESC' as DirectionEnum
    };
}